import { render, staticRenderFns } from "./FoldButton.vue?vue&type=template&id=be26c6b4"
import script from "./FoldButton.vue?vue&type=script&lang=js"
export * from "./FoldButton.vue?vue&type=script&lang=js"
import style0 from "./FoldButton.vue?vue&type=style&index=0&id=be26c6b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports